import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=5b0c41c2"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsExpertCardTaiwan: require('/usr/src/app/components/cards/ExpertCardTaiwan.vue').default,SlidersSliderDefault: require('/usr/src/app/components/sliders/SliderDefault.vue').default})
